import api from '@anm/api';
import useDownloadCsv from '@anm/hooks/useDownloadCsv';

const downloadWebinarAttendees = async (streamId: string) => {
  const data = await api().stream.getWebinarAttendees(streamId);

  const tableData = data.split('\n');
  const [head, ...rows] = tableData;

  useDownloadCsv([[[head]], [rows]], `${streamId}_attendees.csv`)();
};

export default downloadWebinarAttendees;
